import { render, staticRenderFns } from "./Icon4.vue?vue&type=template&id=bc6f1620"
import script from "./Icon4.vue?vue&type=script&lang=js"
export * from "./Icon4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports